exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3gSpPeRSbg{font-size:14px;padding:15px 0;border-bottom:1px solid hsla(0,0%,100%,.2)}._3DfpQrtWe-{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center}._1GXcX0EqY4 a{padding:0 5px;text-decoration:underline;cursor:pointer;color:inherit}._2kNz8lE-vQ a{opacity:.7;cursor:default;text-decoration:none}", ""]);

// exports
exports.locals = {
	"main": "_3gSpPeRSbg",
	"menu": "_3DfpQrtWe-",
	"item": "_1GXcX0EqY4",
	"item--active": "_2kNz8lE-vQ"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!./~/postcss-loader!./~/sass-loader?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./src/react/elements/GoalsPage/BlockHeader.scss
// module id = 685
// module chunks = 5